import React from 'react';
import {
  shape,
  string,
  func,
  arrayOf,
  bool,
  number,
} from 'prop-types';
import { withRouter } from 'react-router-dom';

const RenderMessage = (value, message, messageColor, showRequirements) => {
  const hasValue = (value !== '');
  if (showRequirements && hasValue) {
    return (
      <div id="password-strength">
        <div className="gcc-input-help" id="password-strength-message">
          <span>Password Strength:</span> <span id="password-strength-result" style={{ color: messageColor }}> {message} </span>
        </div>
        <div
          className="gcc-pw-strength-bar"
          style={{ backgroundColor: messageColor }}
          id="password-strength-bar"
        />
      </div>
    );
  } else if (showRequirements) {
    return (
      <div id="password-strength">
        <div className="gcc-input-help" id="password-strength-message">
          <span>Password Strength:</span> <span style={{ color: messageColor }} />
        </div>
        <div className="gcc-pw-strength-bar" style={{ backgroundColor: messageColor }} />
      </div>
    );
  }
  return null;
};

const RenderCriteria = (showRequirements, criteriaList) => {
  if (criteriaList && showRequirements) {
    return (
      <div className="pa2 right-0 f7 mv2 ba br2 b--black-10">
        <p className="ma0 mb1 b lh-title f6">Create a strong password by:</p>
        <div>
          {criteriaList.map(val => (
            <div key={val.code} style={val.match === false ? null : { color: 'green' }}>
              <div style={{ display: 'inline-block', width: '15px' }}>{val.match ? '✔' : '●'}</div>
              {val.message}
            </div>
          ))}
        </div>
      </div>
    );
  }
  return '';
};

export const ForgotPasswordLink = withRouter(({ history, path }) => {
  if (path === 'reset') {
    return (
      <a href={`#${path}`} className="black" onClick={() => { history.push('/reset'); }} >
        Forgot your password?
      </a>
    );
  }
  return (
    <a href={path} className="black">
      Forgot your password?
    </a>
  );
});

const RenderPasswordFunctionality = (type, showHidePassword, forgotPasswordPath) => {
  if (forgotPasswordPath) {
    return (
      <div className="tr absolute bottom--1 right-0 f7" id="reset-password">
        <ForgotPasswordLink path={forgotPasswordPath} />
      </div>
    );
  }
  return (
    <div className="absolute top-0 bottom-0 z-1 flex right-0 f6 mr3" id="show-hide-toggle-wrapper" >
      <span
        className="self-center pointer"
        role="button"
        tabIndex="-1"
        onClick={showHidePassword}
        id="show-hide-toggle"
      >
        {type === 'password' ? 'Show' : 'Hide'}
      </span>
    </div>
  );
};

const PasswordPresentation = ({
  dataTestId,
  input,
  label,
  inputType,
  showHidePassword,
  forgotPasswordPath,
  message,
  criteriaList,
  messageColor,
  showRequirements,
  strength,
  meta: {
    touched,
  },
}) =>
  (
    <div>
      <div className={`gcc-pw ${touched && strength < 3 ? 'has-error' : ''}`} id="password-component" >
        <input
          {...input}
          data-test-id={dataTestId}
          id={input.name}
          type={inputType}
          className={`ba b--black-20 bw1 br3 pa2 pl2 ${input.value ? 'filled' : ''}`}
          data-strength={strength}
        />
        <label htmlFor={input.name} className="f5 pa2 pl2" value={input.value}>{label}</label>
        {RenderMessage(input.value, message, messageColor, showRequirements)}
        {RenderPasswordFunctionality(inputType, showHidePassword, forgotPasswordPath)}
      </div>
      {RenderCriteria(showRequirements, criteriaList)}
    </div>
  );


PasswordPresentation.defaultProps = {
  dataTestId: '',
  forgotPasswordPath: '',
  showRequirements: false,
};

PasswordPresentation.propTypes = {
  input: shape({}).isRequired,
  dataTestId: string,
  label: string.isRequired,
  inputType: string.isRequired,
  showHidePassword: func.isRequired,
  forgotPasswordPath: string,
  message: string.isRequired,
  criteriaList: arrayOf(shape({})).isRequired,
  messageColor: string.isRequired,
  meta: shape({}).isRequired,
  showRequirements: bool,
  strength: number.isRequired,
};

export default PasswordPresentation;
